import { createRouteConfig } from '@ankr.com/utils/createRouteConfig';

const PRICING_PATH = '/pricing/';

export const pricingRoutesConfig = createRouteConfig(
  {
    pricing: {
      path: PRICING_PATH,
      generatePath: () => PRICING_PATH,
    },
  },
  PRICING_PATH,
);
